// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TenantPrescriberPrescriberSearchPrescriberSearchResponse {
    static getAttributeTypeMap() {
        return TenantPrescriberPrescriberSearchPrescriberSearchResponse.attributeTypeMap;
    }
}
TenantPrescriberPrescriberSearchPrescriberSearchResponse.discriminator = undefined;
TenantPrescriberPrescriberSearchPrescriberSearchResponse.additionalProperties = false;
TenantPrescriberPrescriberSearchPrescriberSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "TenantPrescriberPrescriberSearchPrescriberSearchResponseData"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=tenantPrescriberPrescriberSearchPrescriberSearchResponse.js.map